/**
 * RecorderPanel — Digital Recorders panel.
 *
 * Thin wrapper around ItemSection with the recorder image and 3-column grid.
 */
import { useDesktopStore } from '../../stores/desktop'
import type { GenericItem } from '../../stores/desktop'
import { REC_ICON } from '../../assets'
import ItemSection from './ItemSection'

export default function RecorderPanel() {
  const { recorders, setRecorders } = useDesktopStore()
  return (
    <ItemSection
      items={recorders as GenericItem[]}
      setItems={setRecorders as (v: GenericItem[]) => void}
      title="Digital Recorders"
      image={REC_ICON}
      itemLabel="Recorder"
      cols={3}
      cardVariant="officer"
    />
  )
}
